export type DashboardRankingOptions = {
    groupBy: "executor" | "target" | "channel";
    limit: number;
};

export const DEFAULT_DASHBOARD_RANKING_OPTIONS: Readonly<DashboardRankingOptions> = Object.freeze({
    groupBy : "executor",
    limit   : 10,
});

export function resolveDashboardRankingOptions(options?: Partial<DashboardRankingOptions> | null): DashboardRankingOptions {
    const groupBy = [ "executor", "target", "channel" ].includes(options?.groupBy || "")
        ? options!.groupBy!
        : DEFAULT_DASHBOARD_RANKING_OPTIONS.groupBy;
    const limit = Number.isSafeInteger(options?.limit) && options!.limit! >= 3 && options!.limit! <= 20
        ? options!.limit!
        : DEFAULT_DASHBOARD_RANKING_OPTIONS.limit;

    return { groupBy, limit };
}
